import { TextAlign as t } from "../../node_modules/@tiptap/extension-text-align/dist/index.mjs";
const i = t.configure({
  types: ["heading", "paragraph", "listItem"],
  alignments: ["left", "center", "right", "justify"]
});
export {
  i as TextAlignExtension
};
